var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collective-detail',{attrs:{"breadcrumb-route":"events","item-type":"events","item-type-single":"event","custom-item-type":"membership-event"}})}
var staticRenderFns = []

export { render, staticRenderFns }